import { render } from "./dol-dict.vue?vue&type=template&id=28a32017"
import script from "./dol-dict.vue?vue&type=script&lang=js"
export * from "./dol-dict.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__